import { apiClient, getToken, getOrgId } from '@devd-client/api';

export const mergeContributors = (params: any): Promise<any> =>
  apiClient(`/v1/org/${getOrgId()}/contributors/merge`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params),
  });
